import React, { useEffect, useState } from 'react';
import Spinner from '../../shared/Spinner';
import Paginator from '../../shared/Paginator';
import { useNavigate } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { Clipboard } from 'react-bootstrap-icons';
import useApi from '../../hooks/UseApi';
import useAuthentication from '../../auth/useAuthentication';
import moment from 'moment';

const Rows = ({ data, onRowClick, onCopy }) => (
  <>
    {data.map((item) => (
      <tr key={item.id} onClick={() => onRowClick(item)} style={{ cursor: 'pointer' }}>
        <td className="text-nowrap">{moment(item.date).format('DD/MM/YYYY HH:mm:ss')}</td>
        <td className="text-nowrap">{item.machine}</td>
        <td className="text-truncate" style={{ maxWidth: '250px' }}>{item.content_received}</td>
        <td className="text-truncate text-muted" style={{ maxWidth: '200px', fontSize: '0.8rem' }}>{item.url_sent}</td>
        <td className="text-truncate" style={{ maxWidth: '250px' }}>{item.content_sent}</td>
        <td>
          <a href="#!" title="Copiar recibido" onClick={(e) => { e.preventDefault(); e.stopPropagation(); onCopy(item.content_received); }}>
            <Clipboard />
          </a>
        </td>
      </tr>
    ))}
  </>
);

const Logs = () => {
  const today                   = moment().format('YYYY-MM-DD');
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate]     = useState(today);
  const [data, setData]         = useState();
  const [page, setPage]         = useState(1);
  const [total, setTotal]       = useState(0);
  const { get, updating }       = useApi();
  const navigate                = useNavigate();
  const context                 = useAuthentication();

  const getData = () => {
    const machineId = context.user?.selectedMachine?.id;
    let path = `v2/logs?from=${fromDate}&to=${toDate}`;
    if (machineId) path += `&machine=${machineId}`;
    get(path, { page }).then(r => {
      setTotal(parseInt(r.headers['x-paging-total-pages']) || 0);
      setData(r.data);
    });
  };

  useEffect(getData, [fromDate, toDate, page, context.user?.selectedMachine?.id]);

  const handleDateChange = (setter) => (e) => {
    setPage(1);
    setter(e.target.value);
  };

  const handleCopy = (content) => {
    navigator.clipboard.writeText(content);
  };

  return (
    <div className="card">
      <div className="card-body">
        <div className="row align-items-end mb-3">
          <div className="col-auto">
            <Form.Group>
              <Form.Label>Desde</Form.Label>
              <Form.Control type="date" value={fromDate} onChange={handleDateChange(setFromDate)} />
            </Form.Group>
          </div>
          <div className="col-auto">
            <Form.Group>
              <Form.Label>Hasta</Form.Label>
              <Form.Control type="date" value={toDate} onChange={handleDateChange(setToDate)} />
            </Form.Group>
          </div>
        </div>

        {(!data || updating) ? <Spinner /> : (
          <>
            <table className="table table-hover table-striped">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Máquina</th>
                  <th>Recibido</th>
                  <th>URL enviada</th>
                  <th>Enviado</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <Rows data={data} onRowClick={(item) => navigate('/logs/' + item.id)} onCopy={handleCopy} />
              </tbody>
            </table>

            {total > 0 && (
              <div className="d-flex justify-content-end">
                <Paginator currentPage={page} totalPages={total} onChange={setPage} />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Logs;
